"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _icon_wrapper = _interopRequireDefault(require("./icon_wrapper"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var EraseIcon = /*#__PURE__*/function (_React$Component) {
  function EraseIcon() {
    _classCallCheck(this, EraseIcon);
    return _callSuper(this, EraseIcon, arguments);
  }
  _inherits(EraseIcon, _React$Component);
  return _createClass(EraseIcon, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "erase-icon icon"
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        viewBox: "0 0 399 387",
        version: "1.1",
        xmlns: "https://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react["default"].createElement("g", {
        id: "Group-2",
        transform: "translate(-3.000000, -71.000000)"
      }, /*#__PURE__*/_react["default"].createElement("g", {
        id: "Group",
        transform: "translate(230.500000, 231.000000) rotate(-135.000000) translate(-230.500000, -231.000000) translate(94.000000, 42.000000)"
      }, /*#__PURE__*/_react["default"].createElement("rect", {
        id: "Rectangle-2",
        x: "0",
        y: "98",
        width: "273",
        height: "156"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M8,0 L265,0 L265,0 C269.418278,-3.22053779e-14 273,3.581722 273,8 L273,74 L0,74 L0,8 L0,8 C-5.41083001e-16,3.581722 3.581722,8.11624501e-16 8,0 Z",
        id: "Rectangle-2"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M7.10542736e-14,278 L136.5,378 L273,278 L4.97379915e-14,278 Z",
        id: "Combined-Shape"
      })), /*#__PURE__*/_react["default"].createElement("rect", {
        id: "Rectangle",
        x: "193",
        y: "430",
        width: "209",
        height: "28"
      }))));
    }
  }]);
}(_react["default"].Component);
var _default = exports["default"] = (0, _icon_wrapper["default"])(EraseIcon);